import { FormArray, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LinkUsersComponent } from './link-users/link-users.component';
var TabUsersComponent = /** @class */ (function () {
    function TabUsersComponent(matDialog) {
        this.matDialog = matDialog;
        this.reload = new Subject();
        this.searchInputValue = new FormControl();
    }
    TabUsersComponent.prototype.linkUsers = function () {
        var _this = this;
        this.matDialog.open(LinkUsersComponent, {
            panelClass: ['dialog-groups'],
            data: this.groupId,
            hasBackdrop: false
        })
            .beforeClosed()
            .pipe(filter(function (result) { return result && result.reload; }))
            .subscribe(function () {
            _this.reload.next();
        });
    };
    return TabUsersComponent;
}());
export { TabUsersComponent };
